import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { UserEnvironmentService } from '@y42/environment';
import { formatValueConversion } from '@y42/util/format-value-conversion';
import { isNullish } from '@y42/util/nullish';
import { map } from 'rxjs';
import { BaseCellRendererComponent } from '../base-cell-renderer.component';

@UntilDestroy()
@Component({
  selector: 'y42-format-value-conversion-cell-renderer',
  template: `<span>{{ state.numberFormatted }}</span>`,
})
export class FormatValueConversionCellRendererComponent extends BaseCellRendererComponent<{
  number: number;
  prefix?: string;
  suffix?: string;
}> {
  constructor(private readonly userEnvironmentService: UserEnvironmentService) {
    super();
  }

  public readonly state = connectState(this, {
    numberFormatted: this.valueAsSingle$.pipe(
      map((val) => {
        if (isNullish(val)) {
          return '-';
        }

        const formatBy = 'Automatic';
        const fraction = 1;

        const formatted = formatValueConversion(
          val.number,
          this.userEnvironmentService.locale || 'en',
          formatBy,
          fraction,
        );
        return `${val.prefix || ''}${formatted}${val.suffix || ''}`;
      }),
    ),
  });
}
